export default {
  title: "RC kartalarini tarqatish",
  unavailablePage: "Sahifa mavjud emas",
  entityOnModeration: "Sizning yuridik shaxsingiz moderatsiya jarayonida",
  buyTariffToGetAccess: "Sahifaga kirish uchun tarifni sotib olish kerak",
  createShopToGetAccess:
    "Sahifaga va yangi foydalanuvchilarni taklif qilish uchun QR-kodga kirish olish uchun savdo nuqtasini yarating",

  inviteClients: "Mijozlarni taklif qilish",

  branding: {
    title: "Promo-materiallarni brendlash",
    descriptions: [
      "RC GROUPning brendli promo-materiallari bilan ko‘proq mijozlarni jalb qiling! Doimiy mijozlaringiz qaytib kelishsin, yangilari esa ko‘payib borsin!",
      "Yorqin stikerlar va jozibali stol tentlari yordamida kompaniyangizga qiziqishni oshiring! Ularning ustida — mijozlarga xizmat haqidagi ma’lumot, ro‘yxatdan o‘tish uchun QR-kodlar va RC PAY orqali xaridlarda foydali takliflar mavjud!",
      "Siz sodiqlik dasturining ishtirokchisi ekanligingizni ko‘rsating va boshqalardan ajralib turing! Yangi mijozlarni chegirmalar va foydali aksiyalar bilan jalb qiling!",
    ],
    promoLink: "Promo-materiallar havolasi",
    downloadInstruction: "Qo‘llanmani yuklab olish",
  },

  mainInfo: "Asosiy ma’lumot",

  faq: [
    {
      title: "Joylashtirish",
      text: "Biz stol tentini QR-kod va «Bonus kartani yuklab oling! Bonus ballar to‘plang va xaridlar uchun maxsus shartlarga ega bo‘ling» yozuvi bilan kassaning yoniga yoki mijozlar to‘lov qiladigan joyga joylashtirishni tavsiya qilamiz. Masalan, kafelardagi stollarda, do‘kon kassasi yonidagi kutish hududida yoki boshqa ko‘rinadigan joyda.",
    },
    {
      title: "RC KASSA orqali karta olish",
      text: "RC KASSA ilovasidan foydalanib, o‘z QR-kodingizni ko‘rsating: yuqori o‘ng burchakdagi uch nuqtani bosing va «QR-kodni ochish» ni tanlang. Mijozga telefon kamerasi orqali kodni skanerlashni taklif qiling.",
    },
    {
      title: "Xodimlar bilan ishlash",
      text: "Jahon tajribasi shuni ko‘rsatadiki, xodimlar ko‘pincha sodiqlik dasturlarini joriy etishni yoqtirmaydi. Bu nafaqat eski plastik, balki RC Group kabi raqamli yechimlarga ham tegishli. Ba’zi xodimlarga mijozlarga sodiqlik dasturi haqida aytish daromadni kamaytiradi deb tuyulishi mumkin. Bu noto‘g‘ri fikr. Dastur qanchalik keng tarqasa, o‘rtacha chek, xarid chastotasi va brendga sodiqlik shunchalik yuqori bo‘ladi. Bundan tashqari, dastur SMS va boshqa xabarlar xarajatlarini kamaytiradi va mijozlarni yaxshiroq tanish imkonini beradi.",
    },
  ],
};
